import axios from 'axios';

export default class LockerService {
    /**
     * Open a locker.
     *
     * @param {String} token
     * @param {String} lockerId
     */
    static open(token, lockerId) {
        return axios.post(this.endpoint() + '/' + token +'/' + lockerId);
    }

    /**
     * Open a locker and leave.
     *
     * @param {String} token
     * @param {String} lockerId
     */
    static openAndLeave(token, lockerId) {
        return axios.post(this.endpoint() + '/' + token +'/' + lockerId + '/leave');
    }

    /**
     * Get endpoint of API.
     *
     * @return {string}
     */
    static endpoint() {
        return 'electronic-lockers';
    }
}
